import { Link } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { Button, Container, Stack, Text, Title } from '@mantine/core'

export function RouteNotFound() {
  const { t } = useTranslation()

  return (
    <Container py="xl">
      <Stack align="flex-start">
        <Title order={2}>{t('notFound.title')}</Title>
        <Text c="dimmed">{t('notFound.description')}</Text>
        <Button component={Link} to="/" variant="light">
          {t('notFound.backHome')}
        </Button>
      </Stack>
    </Container>
  )
}
